import { useTheme } from "@hooks/useTheme";

const DeleteButton = ({
  children,
  onClick,
  className = "",
  disabled = false,
  type = "button",
  size = "sm",
  ...props
}) => {
  const { colors } = useTheme();

  const sizeClasses = {
    sm: "px-3 py-1.5 text-xs h-8",
    md: "px-4 py-2 text-sm h-10",
    lg: "px-6 py-3 text-base h-12",
  };

  const baseClasses = `inline-flex items-center justify-center rounded-md border font-medium whitespace-nowrap shadow-sm transition-colors ${colors.focusRing2} focus:ring-offset-2 focus:outline-none overflow-hidden`;

  const enabledClasses = `bg-transparent ${colors.borderDangerOutLineButton} ${colors.textDanger}`;
  const disabledClasses = `${colors.borderPrimary} ${colors.textSecondary} cursor-not-allowed opacity-50`;

  const buttonClasses = disabled ? disabledClasses : enabledClasses;

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${baseClasses} ${sizeClasses[size]} ${buttonClasses} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};

export default DeleteButton;
